import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import RegisterForm from '../../components/admin/RegisterForm';
import { useAuth } from '../../contexts/AuthContext';

const RegisterPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    // If already authenticated, redirect to admin dashboard
    if (isAuthenticated) {
      navigate('/admin/dashboard');
    }
  }, [isAuthenticated, navigate]);
  
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ py: 2, textAlign: 'center' }}>
        <Typography variant="h4" component="h1">
          Portfolio Admin Registration
        </Typography>
      </Box>
      <RegisterForm />
    </Box>
  );
};

export default RegisterPage; 